export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  USERS: '/users',
  USER_DETAIL: '/users/:id',
  SETTINGS: '/settings',
  USER_SETTINGS: '/user-settings',
  SETTINGS_LOCAL_CONFIGURATION: '/settings/restaurantconf',
  SETTINGS_CONFIGURE_WHATSAPP: '/settings/whatsapp',
  SETTINGS_MESSAGES: '/settings/messages',
  SETTINGS_MESSAGES_DETAIL: '/settings/messages/:category/:messageCode',
  SETTINGS_OFFICIAL_WHATSAPP_CHANNEL: '/settings/whatsappofficial',
  SETTINGS_TEMPLATES: '/settings/templateslist',
  SETTINGS_TEMPLATES_NEW: '/settings/templateslist/new',
  SETTINGS_WHATSAPP_OFFICIAL: '/settings/whatsappinbox',
  SETTINGS_STRIPE_CONFIGURATION: '/settings/stripe/configuration',
  SETTINGS_STRIPE_TRANSACTIONS: '/settings/stripe/transactions',
  REPORTS: '/reports',
  BOOKING_HISTORY: '/calendar/booking-history',
  BOOKING_HISTORY_DETAILS: '/calendar/booking-history/:bookingCode',
  FORM_HISTORY: '/calendar/form',
  FORM_EDIT: '/calendar/form/:formCode',
  EXTRA_SERVICE_AND_PRODUCT: '/calendar/extra-services',
  FORM_MENU: '/calendar/form-menus',
  FORM_MENU_CREATE: '/calendar/form-menus/new',
  FORM_MENU_EDIT: '/calendar/form-menus/:formMenuCode/edit',
  EVENTS: '/calendar/events',
  EVENTS_CREATE: '/calendar/events/new',
  EVENTS_EDIT: '/calendar/events/:eventId/edit',
  MY_CUSTOMERS: '/marketing/my-customers',
  CUSTOMER_DETAILS: '/marketing/my-customers/:customerCode',
  BULK_MESSAGE: '/marketing/bulk-message',
  AUTOMATION: '/marketing/automation',
  AUTOMATION_CONFIGURATION: '/marketing/automation/configuration',
  AUTOMATION_DASHBOARD: '/marketing/automation/dashboard',
  SURVEYS: '/marketing/surveys',
  BULK_MESSAGE_EDIT: '/marketing/bulk-message/:bulkMessageCode/edit',
  BULK_MESSAGE_DETAILS: '/marketing/bulk-message/:bulkMessageCode/details',
  BULK_MESSAGE_SELECT_CUSTOMERS:
    '/marketing/bulk-message/:bulkMessageCode/customers',
  DATA_COLLECTION_FORMS: '/marketing/data-collection-forms',
  DATA_COLLECTION_FORM_EDIT: '/marketing/data-collection-forms/:id/edit',
  PROMOTIONS: '/marketing/promotions',
  PROMOTION_EDIT: '/marketing/promotions/:promoCode/edit',
  GIFT_CARDS: '/marketing/gift-cards',
  FIDELITY: '/marketing/fidelity',
  DISCOUNT_CARDS: '/marketing/discount-cards',
  FIDELITY_PRIZE_CATALOG: '/marketing/cards/:kind',
  FIDELITY_EDIT: '/marketing/fidelity/:fidelityCode/edit',
  FIDELITY_CREATE_CARD: '/marketing/fidelity/:fidelityCode/create-card',
  FIDELITY_CARD_DETAILS:
    '/marketing/fidelity/:fidelityCode/cards/:fidelityCardId',
  LANDING_PAGES: '/marketing/landing-pages',
  LANDING_PAGE_EDIT: '/marketing/landing-pages/:landingCode',
  /** Public guest landing page — `?cod=` landing code */
  PUBLIC_LANDING: '/landing',
  TAGS: '/marketing/tags',
  PUBLIC_RELATIONS: '/marketing/public-relations',
  ORDERING_DRIVERS: '/orders/drivers',
  ORDERING_CONFIGURATION: '/orders/configuration',
  DELIVERY_ORDERS: '/orders/delivery',
  ORDER_HISTORY: '/orders/delivery/history',
  TAKEAWAY_ORDERS: '/orders/takeaway',
  SUPPLIERS: '/operations/suppliers',
  SUPPLIER_PRODUCTS: '/operations/suppliers/:supplierId/products',
  SUPPLIER_ORDER_HISTORY: '/operations/orders/history',
  SUPPLIER_ORDERS: '/operations/orders',
  SUPPLIER_ORDER_DETAIL: '/operations/orders/:orderId',
  MENU: '/menu/alacarte',
  MENU_EDIT: '/menu/alacarte/:menuCode/edit',
  MENU_PREVIEW: '/menu/alacarte/:menuCode/preview',
  MENU_URL: '/menu/alacarte/:menuCode',
  /** Legacy PRO20 menu URL (`/menualacarte/{menuCode}`) — redirects to MENU_URL */
  MENU_URL_LEGACY: '/menualacarte/:menuCode',
  /** Legacy PRO20 menu URL (`/alacartemenu?menuCode=`) — redirects to MENU_URL */
  MENU_URL_LEGACY_QUERY: '/alacartemenu',
  STAFF: '/staff',
  COLLABORATOR_ROLES: '/staff/collaborator-roles',
  COLLABORATORS: '/staff/collaborators',
  COLLABORATOR_DETAILS: '/staff/collaborators/:employeeId',
  COLLABORATOR_REPORTS: '/staff/collaborator-reports',
  NOTIFICATIONS: '/notifications',
  PUBLIC_BOOKING_FORM: '/bform/:formCode',
  /** Legacy PRO20 booking form URL — redirects to PUBLIC_BOOKING_FORM */
  PUBLIC_BOOKING_FORM_LEGACY: '/bfrm',
  /** Legacy PRO20 public promotion form URL — `?form=` promo code */
  PUBLIC_PROMO_FORM: '/prmfrm',
  /** Legacy PRO20 public fidelity form URL — `?form=` fidelity code */
  PUBLIC_FIDELITY_FORM: '/fidelityfrm',
  /** Public, token-protected recap for a customer's Fidelity card. */
  PUBLIC_FIDELITY_RECAP: '/fidelity/recap/:code/:publicToken',
  /** Public data collection / redirect form — `?form=` form code */
  PUBLIC_DATA_COLLECTION_FORM: '/rfrm',
  PUBLIC_BOOKING_UPDATE: '/update/:bookingCode',
  /** Legacy PRO20 update booking URL — redirects to PUBLIC_BOOKING_UPDATE */
  PUBLIC_BOOKING_UPDATE_LEGACY: '/update',
  /** Guest credit-card request — `/carddetails/{branchCode}/{customerId}` */
  PUBLIC_CARD_DETAILS: '/carddetails/:branchCode/:customerId',
  BACKOFFICE_LOGIN: '/backoffice/login',
  BACKOFFICE2020: '/backoffice2020',
  BACKOFFICE2020_EDIT_ACTIVITY: '/backoffice2020/activities/:branchCode/edit',
  UNAUTHORIZED: '/unauthorized',
  NOT_FOUND: '*',
  FAQ: '/faq',
  /** Legacy URL — redirects to PRIVACY_POLICY */
  PRIVACY: '/privacy',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS: '/terms',
} as const;

export type RouteKey = keyof typeof ROUTES;
